module.exports = __webpack_public_path__ + "static/media/saaya_logo.cd05364c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/saaya_logo.png
// module id = 82
// module chunks = 1